import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectCompanyData } from '../../../../../../redux/selector/system'
import CheckBoxInputControlled from '../../../../inputs/CheckboxInput/controlled'
import TextInput from '../../../../inputs/TextInput'
import AddressFields from '../../../../form/AddressFields'
import { formatAddressInInput } from '../../../../form/CustomerModalForm/helper'
import { InvoiceBillingAddressBlock, InvoiceBillingAddressRecipient, InvoiceBillingAddressSource, InvoiceBillingAddressWrapper } from '../index.styled'

const InvoiceBillingAddress = React.memo(({ isSeparate, toggleSeparate, isFromCustomerCard, register, errors, watch, setValue, setFocus, clearErrors, zIndex }) => {
	const { t } = useTranslation()
	const companyCountryCode = useSelector(selectCompanyData('countryCode'))

	const validateRecipient = useCallback((_, values) =>
		!!(values.billingAddress?.name?.trim() || values.billingAddress?.companyName?.trim())
		|| t('InvoiceModals.customerData.billingRecipientRequired'), [t])

	return (
		<InvoiceBillingAddressWrapper>
			<CheckBoxInputControlled id="billing-address-separate" testId="billing-address-separate"
															 label={t('InvoiceModals.customerData.billingAddressSeparate')}
															 checked={isSeparate} onChange={toggleSeparate} />
			{isSeparate &&
				<InvoiceBillingAddressBlock>
					{isFromCustomerCard &&
						<InvoiceBillingAddressSource>{t('InvoiceModals.customerData.billingAddressFromCustomerCard')}</InvoiceBillingAddressSource>}
					<InvoiceBillingAddressRecipient>
						<TextInput testId="billing-address-name"
											 name="billingAddress.name"
											 tabIndex="909"
											 label={t('AddOrder.Client.form.Name')}
											 errors={errors}
											 errorParser={errors => errors?.billingAddress?.name}
											 register={register}
											 watch={watch('billingAddress.name')}
											 setValue={setValue}
											 color="gray" />
						<TextInput testId="billing-address-company"
											 name="billingAddress.companyName"
											 tabIndex="910"
											 label={t('AddOrder.Client.form.Company')}
											 errors={errors}
											 errorParser={errors => errors?.billingAddress?.companyName}
											 register={register}
											 options={{ validate: validateRecipient }}
											 watch={watch('billingAddress.companyName')}
											 setValue={setValue}
											 color="gray" />
					</InvoiceBillingAddressRecipient>
					<AddressFields dataName="billingAddress"
												 firstTabIndex="911"
												 secondTabIndex="912"
												 thirdTbaIndex="913"
												 fourthTabIndex="914"
												 errors={errors}
												 watch={watch}
												 setValue={setValue}
												 setFocus={setFocus}
												 formatAddress={formatAddressInInput}
												 countryDataRequired={false}
												 geoDataRequired={false}
												 autocompleteRequest={true}
												 register={register}
												 countryCode={companyCountryCode}
												 returnZIndex={zIndex}
												 cols="cols-2"
												 color="gray"
												 clearErrors={clearErrors} />
				</InvoiceBillingAddressBlock>}
		</InvoiceBillingAddressWrapper>
	)
})

InvoiceBillingAddress.displayName = 'InvoiceBillingAddress'
export default InvoiceBillingAddress
